import type { PassengerId } from "../types/primitiveTypes"

export const REASONS = {
  INVALID_DOCUMENT: "invalid_document",
  INVALID_NAME: "invalid_name",
  INVALID_BIRTHDAY: "invalid_birthday",
} as const

export const REQUIRE_PID = [
  REASONS.INVALID_DOCUMENT,
  REASONS.INVALID_NAME,
  REASONS.INVALID_BIRTHDAY,
] as const

export type Status = "pending" | "done"
export type Reason = "invalid_document" | "invalid_name" | "invalid_birthday"
export const NOTE = {
  EMPTY: "empty",
  LATIN: "Name should be in Latin",
  CYRILLIC: "Please provide your name in Cyrilic Azbuka",
} as const
export type Note = typeof NOTE[keyof typeof NOTE]
export type Input = {
  id: number
  pid?: PassengerId
  status: Status
  reason: Reason
  created: number
  fulfilled: number | null | undefined
  note: Note
  passport?: string | null | undefined
}
